import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const ThemeCtx = createContext(null);
export const useTheme = () => useContext(ThemeCtx);

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(localStorage.getItem("theme") || "dark");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("theme", theme);
  }, [theme]);

  useEffect(() => {
    // apply admin default only if user has no explicit preference
    if (!localStorage.getItem("theme")) {
      api.get("/public/settings").then(({ data }) => {
        setThemeState(data.theme_default || "dark");
      }).catch(() => {});
    }
  }, []);

  const setTheme = (t) => setThemeState(t);
  const toggle = () => setThemeState((t) => (t === "dark" ? "light" : "dark"));

  return <ThemeCtx.Provider value={{ theme, setTheme, toggle }}>{children}</ThemeCtx.Provider>;
}
